// React
import React, { Component } from "react";

// Components
import Prices from './Prices.js';
import MarketCap from './MarketCap.js';

// Stores
import { PricingStore } from '../../Stores';

// Styles
import './pricer.css';

// The pricer component is stateless and receives all
// details from prices class
class PriceHolder extends Component {
    
/**********************************************************
 *  Constructor
 **********************************************************/
    constructor(props) {

        super(props);

        this.state = {
            activeTab : PricingStore.getActivePricesTab()
        };

        this.switchTab = this.switchTab.bind(this);
    }

/**********************************************************
 *  Component Lifecycle Functions
 **********************************************************/

    // After first render() is successfully executed, this function is called
    componentDidMount() {

        //console.log('PriceHolder.componentDidMount()');
    }


/**********************************************************
 *  Helper Functions
 **********************************************************/

    // Cache the newly selected tab
    switchTab(newTab) {

        PricingStore.setActivePricesTab(newTab);

        this.setState((prevState,props) => {
            return {
                activeTab : newTab
            }
        });

    }


/**********************************************************
 *  Render
 **********************************************************/

    // Renders the pricer object
    render() {

        var tabContent = (<Prices />);

        if(this.state.activeTab === 'marketcap')
            tabContent = (<MarketCap />);

        return (
            <div className="panel panel-flat bg-theme-700">

                <div className="panel-top-menu">

                    <div className={this.state.activeTab === 'prices' ? 'tab-button active' : 'tab-button'} 
                    onClick={() => this.switchTab('prices')} style={{width:'50%'}}>PRICES</div>
                    <div className={this.state.activeTab === 'marketcap' ? 'tab-button active' : 'tab-button'} 
                    onClick={() => this.switchTab('marketcap')} style={{width:'50%'}}>MARKET CAP</div>
                    {/*<div className={this.state.activeTab === 'favourites' ? 'tab-button active' : 'tab-button left'} 
                    onClick={() => this.switchTab('favourites')} style={{width:'18%'}}>
                    <i className='icon-bookmark3 text-white'></i></div>*/}

                </div>

                { tabContent }

            </div>

        );
    }

}

export default PriceHolder;








// WEBPACK FOOTER //
// ./src/Views/Prices/PriceHolder.js